import http from "../http-common";

class TaxonomyEventService {
  getTaxonomyEventList(eventPath: string) {
    return http.get(`/taxonomy/event/${eventPath}`);
  }
}

export default new TaxonomyEventService();
